<script>
import { SysVars } from "../main";
import axios from "axios";
import { apiDownload, apiORDS, apiORDSpost, urlORDS } from "../shared/api-functions";
import FinanceiroForm from "./financeiro-form";
import Trap from "vue-focus-lock";

export default {
  props: {
    codpedv: '',
    codnf: '',
  },
  components: {
    FinanceiroForm, Trap
  },
  data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      actions: [
        { action: 1, label: 'Configurar Cobranças' },
      ],

      codcta: null,
      codnatfin: null,

      showForm: false,
      codfin: "",
      tipofin: null,

      showDetalhesRetorno: false,
      dadosRetorno: {},

      contaSelecionada: null,

      showModalErros: false,
      titulos: [],

      codCtaTitulosAberto: null,

      confirmaExcluirCobranca: false,
      messageExcluir:
        "Os títulos selecionados serão cancelados da cobrança bancária. Confirma o cancelamento?",
      titleExcluir: "Cancelar Cobrança",

      authcode: null,
      BankingList: null,

      errmessages: null,

      showSuccess: false,

      filtro: {
        codpart: null,
        periodoVencimento: { startDate: null, endDate: null },
        periodoEmissao: { startDate: null, endDate: null },
        doc: ''
      }
    };
  },

  computed: {
    contasconfiguradas: function () {
      if (this.BankingList && this.BankingList.contas)
        return this.BankingList.contas;
      else
        return 0;
    },
    contasList: function () {
      if (this.BankingList && this.BankingList.contas)
        return this.BankingList.contas;
      else
        return [];
    },
    titulosList: function () {
      if (this.BankingList && this.BankingList.titulos)
        return this.BankingList.titulos;
      else
        return [];
    },

    hasTitulosParaEnviar: function () {
      if (this.BankingList && this.BankingList.titulos)
        return this.BankingList.titulos.some(
          item => item.enviarcobranca === true
        );
      return false;
    },

    hasTitulosParaCancelar: function () {
      if (this.BankingList && this.BankingList.titulos)
        return this.BankingList.titulos.some(
          item => item.cancelarcobranca === true
        );
      return false;
    },

    metadataCodnatfin: function () {
      let meta = { ...this.metadata.fin.codnatfin }
      meta.select2.entity = 'natfin/receitas'
      return meta
    },

    habiltaEnviarCobranca: function () {
      return this.hasTitulosParaEnviar;
    },

    habiltaCancelarCobranca: function () {
      return this.hasTitulosParaCancelar;
    },

    showAccountSelection: function () {
      return this.habiltaEnviarCobranca || this.habiltaCancelarCobranca;
    },

    contaSelecionada: function () {
      if (this.BankingList && this.BankingList.contas) {
        return this.BankingList.contas.find(c => c.codcta == this.codcta);
      }
      return null;
    },

    labelBotaoEnviar: function () {
      if (this.contaSelecionada && this.contaSelecionada.cobrancaconfigurada === 'N') {
        return 'Gerar Boleto (Offline)';
      }
      return 'Emitir Cobrança';
    },

    isFiltrado: function () {
      return !!(this.codpedv || this.codnf || this.$route.query.codpedv || this.$route.query.codnf);
    },

    isSelectAll: {
      get: function () {
        const list = this.titulosList.filter(t => (t.enviarcobranca || (!t.enviarcobranca && !t.cancelarcobranca)) || t.cancelarcobranca);
        return list.length > 0 && list.every(t => t.enviarcobranca || t.cancelarcobranca);
      },
      set: function (value) {
        this.titulosList.forEach(t => {
          if (t.enviarcobranca || (!t.enviarcobranca && !t.cancelarcobranca)) {
            t.enviarcobranca = value;
          } else if (t.cancelarcobranca) {
            t.cancelarcobranca = value;
          }
        });
      }
    }

  },

  methods: {
    handleButtonMoreActions(action) {
      if (action == 1) {
        this.$router.push('cobranca-config')
      }
    },

    handleEdit(fin) {
      //abre a tela de edicao
      this.$modalForm(true)
      this.crud = SysVars.crudU
      this.codfin = fin.codfin
      this.tipofin = 'R'
      this.showForm = true
    },

    closeEdit() {
      this.showForm = false;
      this.$modalForm(false);
      this.loadData();
    },

    async handleEnviarCobranca() {
      if (!this.codcta) {
        this.$erpToastError("Selecione a conta bancária para emissão");
        return;
      }

      const listaCodigos = this.BankingList.titulos
        .filter(t => t.enviarcobranca === true)
        .map(t => t.codfin);

      let payload = {
        cobranca: {
          authorization_code: this.authcode,
          codcta: this.codcta,
          codnatfin: this.codnatfin,
          list: listaCodigos,
        }
      };

      this.errmessages = null
      const response = await this.servicoCobranca(payload);
      if (response && response.errmessages) {
        console.log(response)
        this.errmessages = response.errmessages
        this.$erpToastError("Erro ao enviar cobranças");
      }
      if (response && response.status === 'OK') {
        this.showSuccess = true
      }
      this.loadData()

    },

    async handleDownloadBoleto(item) {
      this.errmessages = null

      let payload = {
        cobranca: {
          authorization_code: this.authcode,
          codcta: this.codcta,
          codfin: item.codfin,
          boleto: true,
        }
      };

      const response = await this.servicoCobranca(payload);
      if (response && response.errmessages) {
        this.errmessages = response.errmessages
        this.$erpToastError("Erro ao baixar boleto em PDF");
        return
      }

      try {
        const base64 = response;
        const pdfBytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
        const blob = new Blob([pdfBytes], { type: "application/pdf" });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        const docLabel = item.doc || "boleto";
        link.download = docLabel + ".pdf";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Erro ao exibir boleto PDF:", err);
        this.$erpToastError("Erro ao exibir boleto em PDF.");
      }
    },

    async servicoCobranca(payload) {
      this.showSuccess = false;
      const response = await apiORDSpost(this.$store, "fin/enviacobranca/", payload, "post");
      if (response && response.status === 'AUTHCODE') {
        sessionStorage.setItem('urlRetornoConsentimento', this.$route.fullPath);
        window.location.href = response.url;
        return null
      } else {
        this.authcode = null
      }
      return response
    },

    handleCloseMessage() {
      this.confirmaExcluirCobranca = false;
    },

    handleConfirmaExcluirCobranca() {
      this.confirmaExcluirCobranca = true;
    },

    async handleExcluirCobranca() {
      this.confirmaExcluirCobranca = false;

      this.errmessages = null

      const listaCodigos = this.BankingList.titulos
        .filter(t => t.cancelarcobranca === true)
        .map(t => t.codfin);

      let payload = {
        cobranca: {
          authorization_code: this.authcode,
          list: listaCodigos,
          delete: true,
        }
      };

      const response = await this.servicoCobranca(payload);
      if (response && response.errmessages) {
        this.errmessages = response.errmessages
        this.$erpToastError("Erro ao cancelar cobrança");
        return
      } else {
        this.$erpToastSuccess("A cobrança foi cancelada com sucesso!");
        this.loadData()
      }
    },

    handleConfigurarConta() {
      this.$router.push("/cobranca-config");
    },

    closeModalErros() {
      this.showModalErros = false;
    },

    async loadData() {
      let vCodpedv = this.codpedv || this.$route.query.codpedv;
      let vCodnf = this.codnf || this.$route.query.codnf;

      let q = vCodpedv
        ? `?codpedv=${vCodpedv}`
        : vCodnf
          ? `?codnf=${vCodnf}`
          : '?';

      if (this.filtro.codpart) q += `&codpart=${this.filtro.codpart}`;
      if (this.filtro.doc) q += `&doc=${this.filtro.doc}`;
      if (this.filtro.periodoVencimento.startDate) q += `&dtv_ini=${this.filtro.periodoVencimento.startDate}`;
      if (this.filtro.periodoVencimento.endDate) q += `&dtv_fim=${this.filtro.periodoVencimento.endDate}`;
      if (this.filtro.periodoEmissao.startDate) q += `&dte_ini=${this.filtro.periodoEmissao.startDate}`;
      if (this.filtro.periodoEmissao.endDate) q += `&dte_fim=${this.filtro.periodoEmissao.endDate}`;

      this.BankingList = null
      this.codcta = null
      this.codnatfin = null
      const data = await apiORDS(urlORDS(this.$store, `fin/enviacobranca/${q}`));
      if (data) {
        this.BankingList = data;
        this.codcta = data.codcta;
        this.codnatfin = data.codnatfin;
      }

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },

    handleClose() {
      if (this.$listeners.close) {
        this.$emit('close');
      } else {
        this.$router.back();
      }
    },

    handleConsentimento() {
      //trata o codigo recebido na url quando efetuado o consentimento do usuario
      const { code, iss } = this.$route.query;
      this.authcode = code
    },

  },

  created() {
    this.loadData();

    this.handleConsentimento();
  }
};
</script>

<template>
  <div>
    <div>
      <div class="modal nb-modal-mask" style="display:block; z-index: 1 !important;">
        <Trap>
          <div class="modal-dialog modal-dialog-centered modal-xl" role="document"
            style="width: 80%!important; overflow-y: initial !important">
            <div class="modal-content">
              <div id="modalCobranca" class="modal-body" style="height: 80vh!important; max-height: 100%; overflow-y: auto;">

                <div class="row mb-2">
                  <div class="col-md-10 col-10">
                    <div class="lbl" style="font-size: 20px">
                      <strong>Emissão de Boletos</strong>
                    </div>
                  </div>
                  <div class="col-md-2 col-2 text-right">
                    <v-button icon="fa-close" @click="handleClose"></v-button>
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-12 col-12">
                    <v-button v-if="isFiltrado" title="Atualizar" icon="fa-refresh" @click="loadData"></v-button>
                  </div>
                </div>

                <div class="mainbox mb-4" v-if="!isFiltrado">
                  <div class="row">
                    <div class="col-md-6">
                      <v-label label="Período Vencimento"></v-label>
                      <input-month2 :p-month="filtro.periodoVencimento" @change="loadData"></input-month2>
                    </div>
                    <div class="col-md-6">
                      <v-label label="Período Emissão"></v-label>
                      <input-month2 :p-month="filtro.periodoEmissao" @change="loadData"></input-month2>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <form-field v-model="filtro.codpart" label="Cliente" col="5" type="select2" parent="modalCobranca"
                      :select2="{ entity: 'cliente/', minlength: 0 }"></form-field>
                    <form-field v-model="filtro.doc" label="Nr. Documento" col="3" type="text" @keyup.enter="loadData"></form-field>
                    <div class="col-md-4 text-right pt-4">
                       <v-button title="Pesquisar" icon="fa-search" label="Pesquisar" @click="loadData" :nb-btdef="true"></v-button>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-md-12 col-12" v-if="titulosList && titulosList.length > 0">
                    <table class="table table-hover table-sm">
                      <thead>
                        <tr>
                          <th style="width: 5%">
                            <div v-if="titulosList.length > 0">
                              <input type="checkbox" v-model="isSelectAll" title="Selecionar todos">
                            </div>
                          </th>
                          <th style="width: 10%">Nr Doc</th>
                          <th style="width: 10%">Vencimento</th>
                          <th style="width: 10%">Valor</th>
                          <th style="width: 30%">Nome</th>
                          <th style="width: 10%">Forma Pag</th>
                          <th style="width: 10%">Status</th>
                          <th style="width: 15%">Boleto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in titulosList" :key="index" class="align-middle">
                          <td>
                            <input type="checkbox" v-model="item.enviarcobranca" v-if="item.enviarcobranca || (!item.enviarcobranca && !item.cancelarcobranca)">
                            <input type="checkbox" v-model="item.cancelarcobranca" v-else-if="item.cancelarcobranca">
                          </td>
                          <td>
                            {{ item.doc }}
                            <span v-if="item.parcela"> / {{ item.parcela }}</span>
                          </td>
                          <td>{{ item.vencimento | formatData }}</td>
                          <td>{{ item.vlr | formatValue(2) }}</td>
                          <td>{{ item.nome }}</td>
                          <td>{{ item.formapag }}</td>
                          <td>{{ item.stcobranca }}</td>

                          <td>
                            <v-button v-if="item.boletopdf" icon="fa fa-barcode" @click="handleDownloadBoleto(item)"></v-button>
                            <v-button icon="fa fa-edit" @click="handleEdit(item)"></v-button>
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

      <div class="row">
          <div class="col-md-12 col-12" v-if="errmessages && errmessages.length > 0">
            <alert
              type="error"
              title="Erro na cobrança bancaria"
              :messages="errmessages"></alert>
          </div>
      </div>

      <warnings v-if="showSuccess" :messages="['Cobrança enviada com sucesso! Em alguns instantes o boleto será liberado.']"></warnings>


                <div class="row">
                  <div class="col-6" v-if="showAccountSelection">
                    <div class="row">
                    <form-field v-model="codcta" type="select2" col="12" :metadata="metadata.fin.codcta"
                      name="codcta" :v-errors="errors" v-validate="metadata.fin.codcta.validator"></form-field>
                    </div>
                  </div>
                  <div class="col-6" v-if="habiltaEnviarCobranca">
                    <div class="row">
                    <form-field v-model="codnatfin" type="select2" col="12" :metadata="metadataCodnatfin"
                      name="codnatfin" :v-errors="errors" v-validate="metadata.fin.codnatfin.validator"></form-field>
                    </div>
                  </div>
                </div>


                <div class="row pt-4 pb-4">
                  <div class="col-md-6">
                    <v-button v-if="habiltaEnviarCobranca" :label="labelBotaoEnviar" :nb-btdef="true" @click="handleEnviarCobranca"></v-button>
                    <!-- <v-button label="Mais Ações" @click="handleButtonMoreActions" :actions="actions"></v-button> -->
                    <v-button v-if="habiltaCancelarCobranca" label="Cancelar Cobrança" title="Cancelar os títulos selecionados da cobrança" :danger="true" @click="handleConfirmaExcluirCobranca" class="mr-2"></v-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </Trap>
      </div>
    </div>

    <transition name="fade">
      <financeiro-form v-if="showForm" :index="this.codfin" :tipo="tipofin" :crud="this.crud"
        @closeform="closeEdit"></financeiro-form>
    </transition>

    <md-message v-if="confirmaExcluirCobranca" :message="messageExcluir" :title="titleExcluir"
      @confirm="handleExcluirCobranca()" @close="handleCloseMessage()"></md-message>
  </div>
</template>

<style>
.total strong {
  font-size: 20px;
}

.table>tbody>tr>td {
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/forms/cobranca.vue